import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { take } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class TermosResidenteService {
  constructor(private http: HttpClient) {}

  getAceito(): Observable<boolean> {
    return this.http.get<boolean>('/api/termos-de-uso/residente/aceito').pipe(take(1))
  }

  saveAceitouTermos(): Observable<Object> {
    return this.http.post('/api/termos-de-uso/residente/aceitar', null).pipe(take(1))
  }
}
